import React from 'react';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip
} from 'recharts';
import { DIFFICULTY_COLORS } from '../utils/constants';

const DifficultyAchievementChartSection = React.memo(({
  selectedTest,
  getLevelPieData,
  renderActiveShape,
  activePieIndex,
  setActivePieIndex
}) => {
  const pieData = selectedTest ? getLevelPieData(selectedTest) : [];
  
  // 차트가 로드될 때 가장 큰 값을 가진 섹션 자동 선택 (데스크탱과 동일하게)
  React.useEffect(() => {
    if (pieData && pieData.length > 0 && selectedTest) {
      // 가장 큰 값을 가진 섹션 찾기
      let maxIndex = 0;
      let maxValue = pieData[0].value;
      
      for (let i = 1; i < pieData.length; i++) {
        if (pieData[i].value > maxValue) {
          maxValue = pieData[i].value;
          maxIndex = i;
        }
      }
      
      setActivePieIndex(maxIndex);
    }
  }, [selectedTest]); // selectedTest가 변경될 때마다 실행
  
  if (!selectedTest) return null;

  return (
    <div className="col-span-1 rounded-3xl bg-gray-50 p-3">
      <h4 className="mb-2 text-xs font-medium text-gray-700">난이도별 성취도</h4>
      <div className="flex h-32 items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }} isAnimationActive={false}>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius="50%"
              outerRadius="90%"
              paddingAngle={2}
              dataKey="value"
              cornerRadius={8}
              activeIndex={activePieIndex}
              activeShape={renderActiveShape}
              onMouseEnter={(_, index) => setActivePieIndex(index)}
              onClick={(_, index) => setActivePieIndex(index)}
              onTouchEnd={(_, index) => setActivePieIndex(index)}
              isAnimationActive={false}
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={DIFFICULTY_COLORS[index]} isAnimationActive={false} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
});

export default DifficultyAchievementChartSection;
